import { Link } from 'react-router-dom';
import type { ISectionCardProps } from './ISectionCardProps';

/** Картка розділу (прототип v4 admSections/custSections): назва 700 і опис 13px приглушений; рамка — акцент при наведенні. */
export function SectionCard({ title, desc, to }: ISectionCardProps) {
  return (
    <Link className="sp-card" to={to}>
      <span className="sp-card__title">{title}</span>
      <span className="sp-card__desc">{desc}</span>
    </Link>
  );
}
